// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__H-gR4"};